import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import { store } from './store/store';
import './i18n/config'; // i18n yapılandırmasını import et
import './index.css';
import App from './App';

// Load initial theme from localStorage and apply to document
const savedTheme = localStorage.getItem('app-theme');
const isDark = savedTheme === 'alpine-dark' || savedTheme === 'quartz-dark';
if (isDark) {
  document.documentElement.classList.add('dark');
} else {
  document.documentElement.classList.remove('dark');
}

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </Provider>
  </React.StrictMode>
);

